export default "__VITE_ASSET__De58rlnY__"